import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <main>
      {/* breadcrumb start */}
      <section
        className="page-title mt-[80px]"
        style={{ backgroundImage: "url(assets/images/inner/page-title-bg.jpg)" }}
      >
        <div className="auto-container">
          <div className="title-outer">
            <ul className="page-breadcrumb wow fadeInUp" data-wow-delay=".3s">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Contact Us</li>
            </ul>
            <h1 className="title wow fadeInUp" data-wow-delay=".5s">
              Contact Us
            </h1>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* contact start  */}
      <section class="contact-details fix section-padding">
        <div class="auto-container">
          <div class="row g-5">
            <div class="col-md-6 col-lg-4 wow fadeInLeft" data-wow-delay="00ms" data-wow-duration="1500ms">
              <div class="contact-details-block">
                <div class="inner-box">
                  <div class="icon">
                    <i class="lnr-icon-map-marker"></i>
                  </div>
                  <h4 class="title">Branch Office</h4>
                  <p class="text">201 A, SAS Tower, Medicity, Islampur Colony,
                    Sector 38, Gurugram, Haryana 122001, India</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div class="contact-details-block">
                <div class="inner-box">
                  <div class="icon">
                    <i class="lnr-icon-phone-handset"></i>
                  </div>
                  <h4 class="title">Support Number</h4>
                  <p class="text"><a href="tel:7303047811">+91-730-304-7811</a></p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="1500ms">
              <div class="contact-details-block">
                <div class="inner-box">
                  <div class="icon">
                    <i class="lnr-icon-envelope"></i>
                  </div>
                  <h4 class="title">Email Address</h4>
                  <p class="text"><a href="mailto:admin@zealthix.com">admin@zealthix.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* contact start  */}
    </main>
  );
};

export default Contact;
